export default {
    init() {
    },
    finalize() {
        $(window).on('scroll', function() {
            if($(window).width() < 768) {
                return;
            }

            var scrollPosition = $(window).scrollTop() + $('nav').outerHeight();
            var headerSize = $('header').height() + $('header').scrollTop();

            if(scrollPosition > headerSize) {
                $('.toggle-right-widget.check-availability-btn').addClass('open-home');
                $('.toggle-right-widget.check-availability-btn').addClass('transition');
            } else {
                $('.toggle-right-widget.check-availability-btn').removeClass('open-home')
            }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js